import { faBolt, faPen } from "@fortawesome/pro-light-svg-icons"

import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"
import { StandardMenu } from "../menus/StandardMenu"
import { StandardMenuItem } from "../menus/StandardMenuItem"

type Props = Readonly<{
    anchorEl: HTMLElement | null
    onClose: () => void
    onQuickEdit: () => void
    onFullEdit: () => void
}>

export function OrderEditMenu({ anchorEl, onClose, onQuickEdit, onFullEdit }: Props) {
    const runAndClose = (action: () => void) => () => {
        action()
        onClose()
    }

    return (
        <StandardMenu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={onClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
        >
            <StandardMenuItem icon={faBolt} onClick={runAndClose(onQuickEdit)}>
                <LocalizedStrict id="meeting-service-order-drawer-quick-edit">
                    <span>Quick edit</span>
                </LocalizedStrict>
            </StandardMenuItem>
            <StandardMenuItem icon={faPen} onClick={runAndClose(onFullEdit)}>
                <LocalizedStrict id="meeting-service-order-drawer-full-edit">
                    <span>Full edit</span>
                </LocalizedStrict>
            </StandardMenuItem>
        </StandardMenu>
    )
}
